export default "/_next/static/images/f063c1c6e1ec0f3e576d58ccbd43d3c2.jpg";